var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { I18NLink, t } from "../../I18N";
import { Icon } from "../../UI";
import { processFilters, encodeSearch } from "../actions/libraryActions";
import { createSelector } from 'reselect';

export class LibraryModeToggleButtons extends Component {
  render() {
    const { zoomLevel, zoomOut, zoomIn, showGeolocation, searchUrl, tableViewMode, mapViewMode } =
    this.props;
    return /*#__PURE__*/(
      _jsx("div", { className: "list-view-mode" }, void 0,
      !mapViewMode && /*#__PURE__*/
      _jsx("div", {
        className: `list-view-mode-zoom list-view-buttons-zoom-${zoomLevel} buttons-group ${
        tableViewMode ? 'unpinned-mode' : ''
        }` }, void 0, /*#__PURE__*/

      _jsx("button", {
        className: "btn btn-default zoom-out",
        onClick: zoomOut,
        type: "button",
        "aria-label": t('System', 'Zoom out library view', null, false) }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "search-minus" }), /*#__PURE__*/
      _jsx("span", { className: "tab-link-tooltip" }, void 0, t('System', 'Zoom out'))
      ), /*#__PURE__*/
      _jsx("button", {
        className: "btn btn-default zoom-in",
        onClick: zoomIn,
        type: "button",
        "aria-label": t('System', 'Zoom in library view', null, false) }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "search-plus" }), /*#__PURE__*/
      _jsx("span", { className: "tab-link-tooltip" }, void 0, t('System', 'Zoom in'))
      )
      ), /*#__PURE__*/


      _jsx("div", { className: "list-view-mode-map buttons-group" }, void 0, /*#__PURE__*/
      _jsx(I18NLink, {
        to: `library${searchUrl}`,
        className: "btn btn-default",
        activeclassname: "is-active",
        "aria-label": t('System', 'library list view', null, false) }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "th" }), /*#__PURE__*/
      _jsx("span", { className: "tab-link-tooltip" }, void 0, t('System', 'Cards view'))
      ), /*#__PURE__*/
      _jsx(I18NLink, {
        to: `library/table${searchUrl}`,
        className: "btn btn-default",
        activeclassname: "is-active",
        "aria-label": t('System', 'library table view', null, false) }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "align-justify" }), /*#__PURE__*/
      _jsx("span", { className: "tab-link-tooltip" }, void 0, t('System', 'Table view'))
      ),
      showGeolocation && /*#__PURE__*/
      _jsx(I18NLink, {
        to: `library/map${searchUrl}`,
        className: "btn btn-default",
        activeclassname: "is-active",
        "aria-label": t('System', 'library map view', null, false) }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "map-marker" }), /*#__PURE__*/
      _jsx("span", { className: "tab-link-tooltip" }, void 0, t('System', 'Map view'))
      )

      )
      ));

  }
}











LibraryModeToggleButtons.defaultProps = {
  tableViewMode: false,
  mapViewMode: false,
  zoomIn: null,
  zoomOut: null
};

export const encodedSearch = createSelector(
  (state) => state.search,
  (state) => state.filters,
  (search, filters) => {
    const params = processFilters(search, filters.toJS());
    return encodeSearch(params);
  }
);

export function mapStateToProps(state, props) {
  const { templates } = state;
  const showGeolocation = Boolean(
    templates.find((_t) => _t.get('properties').find((p) => p.get('type') === 'geolocation'))
  );

  return {
    searchUrl: encodedSearch(state.library),
    showGeolocation,
    zoomLevel:
    Object.keys(props).indexOf('zoomLevel') !== -1 ?
    props.zoomLevel :
    state.library.ui.get('zoomLevel')
  };
}
export default connect(mapStateToProps)(LibraryModeToggleButtons);